import { getBorderFocusStyles } from '../../getBorderFocusStyles';
export var datepickerCalendarCellButtonStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables,
        theme = _ref.theme;
    var siteVariables = theme.siteVariables;
    var borderWidth = siteVariables.borderWidth;
    var borderFocusStyles = getBorderFocusStyles({
      variables: siteVariables,
      borderPadding: borderWidth
    });
    return Object.assign({
      textAlign: 'center',
      height: '100%',
      width: '100%',
      cursor: 'pointer',
      border: v.calendarCellBorder,
      padding: v.calendarCellPadding,
      margin: v.calendarCellMargin,
      display: 'table-cell',
      position: 'relative'
    }, borderFocusStyles, {
      backgroundColor: v.calendarCellBackgroundColor,
      color: v.calendarCellColor,
      ':hover': {
        backgroundColor: v.calendarCellHoverBackgroundColor,
        color: v.calendarCellHoverColor
      }
    }, p.quiet && {
      color: v.calendarCellQuietColor
    }, p.selected && {
      color: v.calendarCellSelectedColor,
      backgroundColor: v.calendarCellSelectedBackgroundColor
    }, p.disabled && {
      color: v.calendarCellDisabledColor,
      cursor: 'default',
      backgroundColor: v.calendarCellDisabledBackgroundColor,
      ':hover': {}
    }, p.today && {
      backgroundColor: v.calendarCellTodayBackgroundColor,
      color: v.calendarCellTodayColor,
      borderRadius: v.calendarCellTodayBorderRadius
    });
  }
};